import { Group } from 'phaser';

const { Quad } = window;

const WIDTH = 40;
const HEIGHT = 60;

export default class SingleFlipper extends Group {
  constructor(game) {
    super(game, null, 'single-flipper');
    this.timelineMax = this.game.state.getCurrentState().timelineMax;
    this.number = 0;

    this.bottomFlipper = this.addSpinner(this, 0, 0);
    this.topFlipper = this.addSpinner(this, 0, 0);
  }

  destroy() {
    if (this.bmd) this.bmd.destroy();
    this.bmd = null;
    super.destroy();
  }

  setNumber(number) {
    this.number = number;
    this.bottomFlipper.setNumber(number);
    this.topFlipper.setNumber(number);
  }

  flipToNumber(num) {
    // console.log('flip from', this.number, 'to', num);
    if (this.number === num) return false;
    const flipForward = num < this.number;
    this.number = num;
    this.bottomFlipper.setNumber(num);
    const tl = this.timelineMax();

    let animateOut;
    let animateIn;
    if (flipForward) {
      animateOut = this.timelineMax()
        .add(this.topFlipper.flipBottomOut())
        .set(this.bottomFlipper.shadow, { alpha: 1 }, 0)
        .to(this.topFlipper.shadow, 1, { alpha: 1 }, 0);

      animateIn = this.timelineMax()
        .add(this.bottomFlipper.flipTopIn())
        .to(this.bottomFlipper.shadow, 1, { alpha: 0 }, 0)
        .to(this.topFlipper.shadow, 1, { alpha: 0 }, 0);
    } else {
      animateOut = this.timelineMax()
        .add(this.topFlipper.flipTopOut())
        .set(this.bottomFlipper.shadow, { alpha: 1 }, 0)
        .to(this.topFlipper.shadow, 1, { alpha: 1 }, 0);

      animateIn = this.timelineMax()
        .add(this.bottomFlipper.flipBottomIn())
        .to(this.topFlipper.shadow, 1, { alpha: 0 }, 0)
        .to(this.bottomFlipper.shadow, 1, { alpha: 0 }, 0);
    }

    return tl
      .add(animateOut)
      .call(() => {
        this.addChild(this.bottomFlipper);
        const temp = this.bottomFlipper;
        this.bottomFlipper = this.topFlipper;
        this.topFlipper = temp;
      })
      .add(animateIn)
      .duration(0.5);
  }

  addSpinner(parent, x, y) {
    const grp = this.game.add.group(parent);
    grp.position.set(x, y);

    const topHalf = this.game.add.image(0, HEIGHT / 2, 'numbers', '0', grp);
    topHalf.cropRect = new Phaser.Rectangle(0, 0, WIDTH, HEIGHT / 2);
    topHalf.pivot.y = HEIGHT / 2;

    const bottomHalf = this.game.add.image(0, HEIGHT / 2 + 1, 'numbers', '0', grp);
    bottomHalf.cropRect = new Phaser.Rectangle(0, HEIGHT / 2, WIDTH, HEIGHT / 2);

    grp.bottomHalf = bottomHalf;
    grp.topHalf = topHalf;

    // NOTE the shadow is shared between both halves.
    grp.shadow = this.addShadow(grp, 0, 0);
    grp.shadow.alpha = 0;

    grp.setNumber = (num) => {
      topHalf.frameName = num.toString();
      bottomHalf.frameName = num.toString();
    };
    grp.flipTopIn = () =>
      this.timelineMax()
        .set(topHalf.scale, { y: 0 })
        .to(topHalf.scale, 1, { y: 1, ease: Quad.easeOut });
    grp.flipTopOut = () =>
      this.timelineMax()
        .to(topHalf.scale, 1, { y: 0, ease: Quad.easeIn })
        .set(topHalf.scale, { y: 1 });
    grp.flipBottomIn = () =>
      this.timelineMax()
        .set(bottomHalf.scale, { y: 0 })
        .to(bottomHalf.scale, 1, { y: 1, ease: Quad.easeOut });
    grp.flipBottomOut = () =>
      this.timelineMax()
        .to(bottomHalf.scale, 1, { y: 0, ease: Quad.easeIn })
        .set(bottomHalf.scale, { y: 1 });
    return grp;
  }

  addShadow(parent, x, y) {
    return this.game.add.image(x, y, 'numbers', 'shadow', parent);
  }
}
